export const pasteText = () => navigator.clipboard.readText()

export const copyText = (text: string) => navigator.clipboard.writeText(text)